import { useState } from 'react';
import { Skeleton, Tabs } from 'antd';
import ProductItem from './ProductItem';
import Pagination from '../Pagination';

import { GenerateIcon } from './generateIcon';
import Empty from '../Empty';
import isEmpty from 'lodash/isEmpty';
import ShopifyProductItem from './ShopifyProductItem';
import styles from './index.module.scss';

export default function GenLoading() {
    const [generateLoading, setGenerateLoading] = useState(false);

    const handleGenerate = () => {
        setGenerateLoading(true);
    };
    return (
        <div className={styles.loadingBreathe}>
            <i className="loadingBreatheItem"></i>
            <i className="loadingBreatheItem"></i>
            <i className="loadingBreatheItem"></i>
        </div>
    );
}
